import React from 'react';
import { useSessionAreaName } from '@/platform-services/session';
import { InitialSelectionPage } from '@/search-for-retail/generic/page-context-selection';
import { useIsActiveAreaValid } from '@/search-for-retail/generic/area-pages/hooks/use-is-active-area-valid';
export const AreaPageWrapper = ({ children, titleMessageKey, title }) => {
    const activeArea = useSessionAreaName();
    const areaIsValid = useIsActiveAreaValid();
    if (!activeArea || !areaIsValid) {
        return (<InitialSelectionPage titleComponent={title} titleMessageKey={titleMessageKey} selectionMessageKey='SELECT_COLLECTION_AND_AREA_PAGE_TEXT'/>);
    }
    return (<React.Fragment>
      {children}
    </React.Fragment>);
};
export default AreaPageWrapper;
